export interface INavigationRoute {
  name: string
  displayName: string
  meta: {
    icon: string
    role: string[]
  }
  children?: INavigationRoute[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: {
        icon: 'vuestic-iconset-dashboard',
        role: ['ADMIN'],
      },
    },
    {
      name: 'subscription',
      displayName: 'menu.subscription',
      meta: {
        icon: 'subscriptions',
        role: ['ADMIN', 'MANAGER'],
      },
    },
    {
      name: 'expert',
      displayName: 'menu.expert',
      meta: {
        icon: 'groups_2',
        role: ['ADMIN', 'ASSISTANT'],
      },
    },
    {
      name: 'tariff',
      displayName: 'menu.tariff',
      meta: {
        icon: 'groups_2',
        role: ['ADMIN', 'MANAGER', 'HEAD'],
      },
    },
    {
      name: 'users',
      displayName: 'menu.users',
      meta: {
        icon: 'group',
        role: ['ADMIN'],
      },
    },
    {
      name: 'projects',
      displayName: 'menu.projects',
      meta: {
        icon: 'folder_shared',
        role: ['ADMIN'],
      },
    },
    {
      name: 'payments',
      displayName: 'menu.payments',
      meta: {
        icon: 'credit_card',
        role: ['ADMIN'],
      },
      children: [
        {
          name: 'payment-methods',
          displayName: 'menu.payment-methods',
          meta: {
            role: ['ADMIN'],
          },
        },
        {
          name: 'pricing-plans',
          displayName: 'menu.pricing-plans',
          meta: {
            role: ['ADMIN'],
          },
        },
        {
          name: 'billing',
          displayName: 'menu.billing',
          meta: {
            role: ['ADMIN'],
          },
        },
      ],
    },
    {
      name: 'auth',
      displayName: 'menu.auth',
      meta: {
        icon: 'login',
        role: ['ADMIN'],
      },
      children: [
        {
          name: 'login',
          displayName: 'menu.login',
          meta: {
            role: ['ADMIN'],
          },
        },
        {
          name: 'signup',
          displayName: 'menu.signup',
          meta: {
            role: ['ADMIN'],
          },
        },
        {
          name: 'recover-password',
          displayName: 'menu.recover-password',
          meta: {
            role: ['ADMIN'],
          },
        },
      ],
    },

    {
      name: 'faq',
      displayName: 'menu.faq',
      meta: {
        icon: 'quiz',
        role: ['ADMIN'],
      },
    },
    {
      name: '404',
      displayName: 'menu.404',
      meta: {
        icon: 'vuestic-iconset-files',
        role: ['ADMIN'],
      },
    },
    {
      name: 'preferences',
      displayName: 'menu.preferences',
      meta: {
        icon: 'manage_accounts',
        role: ['ADMIN'],
      },
    },
    {
      name: 'settings',
      displayName: 'menu.settings',
      meta: {
        icon: 'settings',
        role: ['ADMIN'],
      },
    },
  ] as INavigationRoute[],
}
